import { Pipe, PipeTransform } from '@angular/core';

/**
 * Converts bytes to human-readable file size
 *
 * Usage:
 * {{ fileSize | fileSize }}
 *
 * Examples:
 * 1024 → "1 KB"
 * 1536 → "1.5 KB"
 * 1048576 → "1 MB"
 * 5242880 → "5 MB"
 */
@Pipe({
  name: 'fileSize',
  standalone: true,
})
export class FileSizePipe implements PipeTransform {
  transform(bytes: number, decimals: number = 1): string {
    if (bytes === 0) return '0 Bytes';
    if (!bytes || bytes < 0) return 'N/A';

    const k = 1024;
    const dm = Math.max(decimals, 0);
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return Number.parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }
}
